<app-floating-visor style="position: absolute; user-select: none; z-index: 120; height: 0px;" [width]="previewSize"
  [height]="previewSize" [left]="previewLeft" [top]="70" [showWindowingTool]="showWindowingTool" (closeVisor)="showMenu()">
</app-floating-visor>

<app-download-modal-mobile></app-download-modal-mobile>

<div class="w-100 h-100 d-flex justify-content-center align-items-center"
  style="position:absolute;top:0;left:0; z-index: 999; background-color: rgba(139, 139, 139, 0.486);"
  *ngIf='showSpinner'>
  <div class="spinner-border text-light" role="status">
  </div>
  <span class="ms-3">Cargando...</span>
</div>

<div class="h-100" *ngIf="bookService.currentBookWithReports!=null">

  <app-header *ngIf="!visorOpen" [token]="token" (initVerticalTour)="startVerticalMobileTour()" (sendMail)="sendMail($event)"></app-header>
  
  <!-- ESTO AQUÍ ES LA CABECERA ¿? -->

   <!--  <div class="row g-0 justify-content-between align-items-center">
    <div class="col-6">
      <div class="h-100 w-100 d-flex justify-content-center align-items-center">
        <span class='ps-icons icon-debrain clickable' *ngIf="company==Company.DEBRAIN"
          style="font-size: 14px; color:turquoise !important;" height="14"
          (click)="window.location.href='http://www.debrain-he.com'"></span>
        <span class='prp-icons icon-m3m-logo clickable' *ngIf="company==Company.M3M"
          style="font-size: 18px; color:#2AA5F5!important;" height="18"
          (click)="window.location.href='http://www.m3meuropa.com'"></span>
      </div>
    </div>
    <div class="col-6">
      <div class="h-100 w-100 d-flex justify-content-center align-items-center">
        <img src='assets/img/Logo Vertical.svg' height="35"
          (click)="(company==Company.DEBRAIN) ? window.location.href='http://www.debrain-he.com/products?product=DIGITALBOOK' : window.location.href='http://www.m3meuropa.com/products?product=DIGITALBOOK'">
      </div>
    </div>
     //// <div class="col-4">
        <div class="h-100 w-100 d-flex justify-content-end align-items-center">
          <div class='close-book me-3 clickable' (click)='closeSelf()'><span>x</span></div>
        </div>////
      </div> 
  </div> -->

  <!-- HASTA AQUÍ ES LA CABECERA ¿? -->


  <div class="row g-0 mt-1" style="height: 90%; align-items: center;" id="book-container">
    <div class="col-12">
      <!-- <div id="bookCarousel" class="carousel slide" data-ride="carousel" data-interval="0" data-keyboard='true'
        data-touch='false'>
        <div class="carousel-inner">
          <div class="page report-container carousel-item carousel-page"
            *ngFor='let page of bookService.currentBookWithReports.pages'>
            <div style="height: 100%;"
              [ngStyle]="{backgroundColor: (page.type == BookPageType.IMAGES) ? 'black' : 'white'}">
              <div *ngFor='let img of page.bookImages' style="display: inline-block; position: relative;"
                (click)="(page.type == BookPageType.IMAGES && img.dicomFile) ? openPreview(img) : null"
                [ngClass]="{clickable:img.dicomFile!=null}" class='book-image-container'
                [ngStyle]="{height: img.height+'%', width: img.width+'%'}"
                [style.borderColor]="(page.type == BookPageType.IMAGES && img.isKo) ? '#f2c63d38' : ''">
                <img style="width: 100%; height: 100%; object-fit: contain;"
                  [src]="imagesService.getImage(img.pngFile)">
                <span *ngIf="(img.type == BookImageType.SERIES) && img.dicomFile"
                  style="position: absolute;top: 4px;left: 4px;">serie</span>
                <span *ngIf="(img.type == BookImageType.CINE) && img.dicomFile"
                  style="position: absolute;top: 4px;left: 4px;">cine</span>
                <span *ngIf="(img.type == BookImageType.GRID) && img.dicomFile"
                  style="position: absolute;top: 4px;left: 4px;">grid</span>
                <div *ngIf="(page.type == BookPageType.IMAGES) && img.isKo"
                  style="position: absolute;top: 2px;left: 4px;color: #f2c53de0">
                  <span class='d-block' style="font-size: small;">Imagen</span>
                  <span class='d-block' style="font-size: small;">Clave</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div id="bookCarousel" class="carousel slide" data-bs-keyboard='true' data-bs-touch="false">
        <div class="carousel-inner">
          <div class="page report-container carousel-item"
            *ngFor='let page of bookService.currentBookWithReports.pages'>
            <div style="height: 100%;" *ngIf="page != null && page.type != BookPageType.REPORT"
              [ngStyle]="{backgroundColor: (page.type == BookPageType.IMAGES) ? 'black' : 'white'}">
              <div *ngFor='let img of page.bookImages' style="display: inline-block; position: relative;"
                (click)="(page.type == BookPageType.IMAGES && img.dicomFile) ? openPreview(img) : null"
                [ngClass]="{clickable:img.dicomFile!=null}" class='book-image-container'
                [ngStyle]="{height: img.height+'%', width: img.width+'%'}"
                [style.borderColor]="(page.type == BookPageType.IMAGES && img.isKo) ? '#f2c63d38' : ''">
                <img draggable="false" style="width: 100%; height: 100%; object-fit: contain;"
                  [src]="imagesService.getImage(img.pngFile)" *ngIf="img.mp4File==null">
                <video draggable="false" class="multiframe-video" muted
                  *ngIf="img.mp4File!=null && imagesService.getSingleImage(img.mp4File)!=null"
                  style="width: 100%;height: 100%;">
                  <source [src]="imagesService.getSingleImage(img.mp4File)" type="video/mp4">
                  Your browser does not support the video.
                </video>
                <span *ngIf="(img.type == BookImageType.SERIES) && img.dicomFile"
                  style="position: absolute;top: 4px;left: 4px;">serie</span>
                <span *ngIf="(img.type == BookImageType.CINE) && img.dicomFile"
                  style="position: absolute;top: 4px;left: 4px;">cine</span>
                <span *ngIf="(img.type == BookImageType.GRID) && img.dicomFile"
                  style="position: absolute;top: 4px;left: 4px;">grid</span>
                <div *ngIf="(page.type == BookPageType.IMAGES) && img.isKo"
                  style="position: absolute;top: 2px;left: 4px;color: #f2c53de0">
                  <span class='d-block' style="font-size: small;">Imagen</span>
                  <span class='d-block' style="font-size: small;">Clave</span>
                </div>
              </div>
            </div>
            <div style="height: 90%; margin-top: 15%;" *ngIf="page.type == BookPageType.REPORT">
              <div style="display: inline-block; position: relative; height: 93%; "
                class='book-image-container'>
                <div (click)="downloadReport()"
                  style="background-color: white;padding: 5px;border-right: 1px solid black;width: 100%;height: 100%;">
                  <img draggable="false" style="object-fit: contain; height: 93%;width: auto;" [src]="page.report">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row g-0 mt-1">
    <!-- <ol class="carousel-indicators">
      <li data-target="#bookCarousel" class="indicator" attr.data-slide-to="{{i}}" [ngClass]="{active:isVerticalPageActive(i)}"
        *ngFor='let page of bookService.currentBookWithReports.pages, let i = index;'></li>
    </ol> -->
    <div class="carousel-indicators">
      <button *ngFor='let page of bookService.currentBookWithReports.pages, let i = index;' type="button"
        data-bs-target="#bookCarousel" attr.data-bs-slide-to="{{i}}" [ngClass]="{active:isVerticalPageActive(i)}"
        aria-current="true" aria-label="Slide 1"></button>
    </div>
  </div>

  <!--<div class="share-icon-container left clickable" (click)='this.shareStudyModal.open()'>
    ////////<div class="share-icon-container left clickable disabled" (click)='this.shareStudyModal.open()'> ///////
    <span style="display: block;">
      <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20">
        <path fill="white"
          d="M720-80q-50 0-85-35t-35-85q0-7 1-14.5t3-13.5L322-392q-17 15-38 23.5t-44 8.5q-50 0-85-35t-35-85q0-50 35-85t85-35q23 0 44 8.5t38 23.5l282-164q-2-6-3-13.5t-1-14.5q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35q-23 0-44-8.5T638-672L356-508q2 6 3 13.5t1 14.5q0 7-1 14.5t-3 13.5l282 164q17-15 38-23.5t44-8.5q50 0 85 35t35 85q0 50-35 85t-85 35Zm0-640q17 0 28.5-11.5T760-760q0-17-11.5-28.5T720-800q-17 0-28.5 11.5T680-760q0 17 11.5 28.5T720-720ZM240-440q17 0 28.5-11.5T280-480q0-17-11.5-28.5T240-520q-17 0-28.5 11.5T200-480q0 17 11.5 28.5T240-440Zm480 280q17 0 28.5-11.5T760-200q0-17-11.5-28.5T720-240q-17 0-28.5 11.5T680-200q0 17 11.5 28.5T720-160Zm0-600ZM240-480Zm480 280Z" />
      </svg>
    </span>
    <span class="label text-golden">Compartir</span>
  </div>-->

  <!--<div class="share-icon-container right clickable" (click)='downloadReport()'>
    ///////<div class="share-icon-container right clickable disabled" (click)='download()'> /////
    <span *ngIf="downloading==null">
      <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20">
        <path fill="white"
          d="M320-240h320v-80H320v80Zm0-160h320v-80H320v80ZM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80H240Zm280-520v-200H240v640h480v-440H520ZM240-800v200-200 640-640Z" />
      </svg>
    </span>
    <span *ngIf="downloading!=null">
      {{downloading}}%
    </span>
    <span class="label text-golden">Informe</span>
  </div>-->

  <!--<div class="share-icon-container middle clickable" (click)='showTour()'>
    <span style="display: block;">
      
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M28.3332 15.0001C28.3332 12.7899 27.4552 10.6703 25.8924 9.10752C24.3296 7.54472 22.21 6.66675 19.9998 6.66675C17.7897 6.66675 15.6701 7.54472 14.1073 9.10752C12.5445 10.6703 11.6665 12.7899 11.6665 15.0001C11.6665 15.4421 11.8421 15.866 12.1547 16.1786C12.4672 16.4912 12.8911 16.6667 13.3332 16.6667C13.7752 16.6667 14.1991 16.4912 14.5117 16.1786C14.8242 15.866 14.9998 15.4421 14.9998 15.0001C14.9998 14.0112 15.2931 13.0445 15.8425 12.2222C16.3919 11.4 17.1728 10.7591 18.0864 10.3807C19 10.0022 20.0054 9.90323 20.9753 10.0962C21.9452 10.2891 22.8361 10.7653 23.5354 11.4645C24.2346 12.1638 24.7108 13.0547 24.9038 14.0246C25.0967 14.9945 24.9977 15.9999 24.6192 16.9135C24.2408 17.8271 23.5999 18.608 22.7777 19.1574C21.9554 19.7068 20.9887 20.0001 19.9998 20.0001C19.5578 20.0001 19.1339 20.1757 18.8213 20.4882C18.5088 20.8008 18.3332 21.2247 18.3332 21.6667V25.0001C18.3332 25.4421 18.5088 25.866 18.8213 26.1786C19.1339 26.4912 19.5578 26.6667 19.9998 26.6667C20.4419 26.6667 20.8658 26.4912 21.1783 26.1786C21.4909 25.866 21.6665 25.4421 21.6665 25.0001V23.1667C23.5488 22.7825 25.2405 21.7598 26.4553 20.2716C27.6702 18.7834 28.3336 16.9212 28.3332 15.0001Z"
          fill="url(#paint0_linear_400_1738)" />
        <path
          d="M20.0002 33.3333C20.9206 33.3333 21.6668 32.5871 21.6668 31.6667C21.6668 30.7462 20.9206 30 20.0002 30C19.0797 30 18.3335 30.7462 18.3335 31.6667C18.3335 32.5871 19.0797 33.3333 20.0002 33.3333Z"
          fill="url(#paint1_linear_400_1738)" />
        <defs>
          <linearGradient id="paint0_linear_400_1738" x1="13.7573" y1="10.406" x2="28.0467" y2="20.3292"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#D79314" />
            <stop offset="0.5" stop-color="#FDDA98" />
            <stop offset="1" stop-color="#D79314" />
          </linearGradient>
          <linearGradient id="paint1_linear_400_1738" x1="18.7517" y1="30.6232" x2="21.2517" y2="32.7065"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#D79314" />
            <stop offset="0.5" stop-color="#FDDA98" />
            <stop offset="1" stop-color="#D79314" />
          </linearGradient>
        </defs>
      </svg>

    </span>
    <span class="label text-golden">Tour</span>
  </div>-->

</div>

<app-animations></app-animations>
<!--<app-share-study (sendMail)="sendMail($event)"></app-share-study>-->
<!--<app-share-study-mobile (sendMail)="sendMail($event)"></app-share-study-mobile>-->